<div class="footer-card" [ngClass]="{'footer-card--no-tax': estimate.line_items.length == 0}">
  <div class="footer-card__total">
    <span>{{ 'payment-info.footer-card.total-taxable' | translate }}</span>
    <span>{{estimate.total_without_taxes | countryCurrency: estimate.currency_code:'symbol':'1.1-3':locale}}</span>
  </div>
  <div class="footer-card__total">
      <span *ngIf="estimate.line_items.length != 0">{{'payment-info.footer-card.total-taxes' | translate: {vat: estimate.line_items[0].tax_rate} }}</span>
      <span *ngIf="estimate.line_items.length == 0">{{'payment-info.footer-card.total-taxes-zero' | translate }}</span>
      <span>{{ estimate.taxes | countryCurrency: estimate.currency_code:'symbol':'1.1-3':locale }}</span>
  </div>
  <hr/>
  <div class="footer-card__total">
      <span>{{ 'payment-info.footer-card.total' | translate }}</span>
      <span>{{estimate.total_with_taxes | countryCurrency: estimate.currency_code:'symbol':'1.1-3':locale}}</span>
  </div>
  <div *ngIf="estimate.credits_applied && estimate.credits_applied > 0">
      <div class="footer-card__credits">
          <span class="item-name">{{ 'payment-info.footer-card.credits' | translate }}</span>
          <span class="item-price">-{{estimate.credits_applied | countryCurrency:
              estimate.currency_code:'symbol':'1.1-3':locale}}</span>
      </div>
      <div class="footer-card__total">
          <span>{{ 'payment-info.footer-card.amount-due' | translate }}</span>
          <span>{{estimate.amount_due | countryCurrency: estimate.currency_code:'symbol':'1.1-3':locale}}</span>
      </div>
  </div>
</div>